<template>
  <div>
    <table class="table table-bordered table-RWD table-horizontal-RWD  form-inline">
     <tbody>
      <tr>
        <th class="w15"><span class="">業績月份</span></th>
        <td class="w35">{{previewItem.period}}</td>
        <th class="w15"><span class="">佣金類別</span></th>
        <td class="w35">{{previewItem.bTypeName}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">受理編號</span></th>
        <td class="w35">{{previewItem.sNo}}</td>
        <th class="w15"><span class="">保單編號</span></th>
        <td class="w35">{{previewItem.iNo}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">要保人姓名</span></th>
        <td class="w35">{{previewItem.payerName}}</td>
        <th class="w15"><span class="">要保人ID</span></th>
        <td class="w35">{{previewItem.payerID}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">被保人姓名</span></th>
        <td class="w35">{{previewItem.insName}}</td>
        <th class="w15"><span class="">被保人ID</span></th>
        <td class="w35">{{previewItem.insID}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">被保人生日</span></th>
        <td class="w35">{{formatDate(previewItem.insBirth)}}</td>
        <th class="w15"><span class=""></span></th>
        <td class="w35"></td>
      </tr>
      <tr>
        <th class="w15"><span class="">保險公司</span></th>
        <td class="w35">{{previewItem.aliasName}}</td>
        <th class="w15"><span class="">主附約</span></th>
        <td class="w35">{{previewItem.mainName}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">險種代碼</span></th>
        <td class="w35">{{previewItem.prodCode}}</td>
        <th class="w15"><span class="">險種名稱</span></th>
        <td class="w35">{{previewItem.prodName}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">年期</span></th>
        <td class="w35">{{previewItem.yp}}</td>
        <th class="w15"><span class="">年度</span></th>
        <td class="w35">{{previewItem.yr}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">繳別</span></th>
        <td class="w35">{{previewItem.itemName}}</td>
        <th class="w15"><span class="">生效日</span></th>
        <td class="w35">{{formatDate(previewItem.sDate)}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">保額</span></th>
        <td class="w35">{{previewItem.benefit | $commaFormat}}</td>
        <th class="w15"><span class="">保費</span></th>
        <td class="w35">{{previewItem.fyp | $commaFormat}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">獎金名稱</span></th>
        <td class="w35">{{previewItem.srcItemName}}</td>
        <th class="w15"><span class="">營業員獎金</span></th>
        <td class="w35">{{previewItem.fyc | $commaFormat}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">佣金性質</span></th>
        <td class="w35">{{previewItem.bKindName}}</td>
        <th class="w15"><span class="">佣金收入</span></th>
        <td class="w35">{{previewItem.fya | $commaFormat}}</td>
      </tr>
      <tr>
        <th class="w15"><span class="">最近繳款日</span></th>
        <td class="w35">{{formatDate(previewItem.iDate)}}</td>
        <th class="w15"><span class="">獎金發放日期</span></th>
        <td class="w35">{{formatDate(previewItem.srcdate)}}</td>
      </tr>
     </tbody>
    </table>
  </div>
</template>
<script>
import format from 'date-fns/format'
export default {
  name: 'commission-preview',
  props: {
    previewItem: {
      type: Object
    }
  },
  methods: {
    formatDate (d) {
      let df = format(new Date(d), 'yyyy/MM/dd')
      return df
    }
  }
}
</script>
<style lang="stylus" scoped>
.the-table {
  margin: 30px 0;
  width: 100%;

  tr {
    background-color: #fff;
  }

  th {
    text-align: center;
    border-bottom: 1px solid #a0a0a0;
  }

  td {
    font-weight: bolder;
    padding: 5px 0;
  }
}
</style>
